import {
  InvoiceSyncData,
  InvoiceSyncLine,
  InvoiceSyncLineFormatted,
} from '@accounting-integrations/interfaces/accounting-integrations';
import ToolsHelper from '@core/services/tools.helper';
import AbstractField from '@shared/components/forms/inputs/abstract-field/abstract-field';
import FieldWrapper from '@shared/components/forms/inputs/field-wrapper/field-wrapper.vue';
import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'bpc-invoice-sync-data-display',
  components: {
    'bpc-field-wrapper': FieldWrapper,
  },
})
export default class InvoiceSyncDataDisplay extends mixins(AbstractField) {
  @Prop(Object) readonly value: InvoiceSyncData;

  public lineTableFields = [
    {
      key: 'account_number',
      label: this.$t('global.fields.invoice_sync_data.lines.account_number'),
    },
    {
      key: 'analytic_code',
      label: this.$t('global.fields.invoice_sync_data.lines.analytic_code'),
    },
    {
      key: 'total_tax',
      label: this.$t('global.fields.invoice_sync_data.lines.total_tax'),
    },
    {
      key: 'total_amount',
      label: this.$t('global.fields.invoice_sync_data.lines.total_amount'),
    },
  ];

  get model(): InvoiceSyncData {
    return this.value;
  }
  set model(val: InvoiceSyncData) {
    this.$emit('input', val);
    if (this.eventsConfig && this.eventsConfig.emit) {
      this.eventsConfig.emit.forEach(event => {
        this.$root.$emit(event, val);
      });
    }
  }

  get centerData(): string {
    return this.model?.center_data || '';
  }

  get contactData(): string {
    return this.model?.contact_data || '';
  }

  get lines(): InvoiceSyncLineFormatted[] {
    const formattedLines = this.model?.lines || [];
    return formattedLines.map(item => {
      return {
        ...item,
        total_tax: ToolsHelper.formatPrice(item.total_tax),
        total_amount: ToolsHelper.formatPrice(item.total_amount),
      };
    });
  }

  formatPrice(price: number): number {
    return Math.round(price * 100) / 100;
  }

  get totalAmount(): number {
    const total = this.model?.total_amount || 0;
    return Number(total);
  }

  get paidAmount(): number {
    const total = this.model?.paid_amount || 0;
    return Number(total);
  }
}
